<template>
  <div
    class="
          daohang
          gWidth
          padding-left-lg
          flex
          text-sm
          padding-top
          bg-white
        "
  >
    <span class="flex align-center">
      <span class="position margin-right-xs">
        <img src="@/assets/position.svg" />
      </span>
      <span class="weizhi">您的位置：</span>
    </span>
    <span>
      <span>
        <router-link to="/" class="text-sm">首页</router-link>
        <span>&gt;</span>
      </span>
      <span v-for="(item, index) in posGuids" :key="index">
        <span v-if="item.link">
          <router-link
            :to="item.link"
            class="text-sm"
            v-html="item.title"
          ></router-link>
          <span>&gt;</span>
        </span>
        <span v-else>
          <span class="text-sm grayss" v-html="item.title"></span>
          <span v-if="index < posGuids.length - 1">&gt;</span>
          <!-- 0 1 2   3 -1 2  -->
        </span>
      </span>
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["posGuids"],
};
</script>
<style></style>
